import { Link, useMatch } from 'react-router';

import WizeLogo from 'my-components/WizeLogo';

const rootCss = ({ breakpoints, spacing }) => ({
  display: 'block',
  flex: '0 0 40px',
  marginRight: spacing(2),
  [breakpoints.down('sm')]: { marginRight: spacing(1) },
});

export default function AppBarLogo(props) {
  const { logoDashClassName, logoTickClassName, to } = props;

  const match = useMatch(to);

  const logo = (
    <WizeLogo
      css={match ? rootCss : undefined}
      logoDashClassName={logoDashClassName}
      logoTickClassName={logoTickClassName}
      style={{ display: 'block' }}
    />
  );

  if (match) {
    return logo;
  } else {
    return (
      <Link css={rootCss} to={to}>
        {logo}
      </Link>
    );
  }
}
